function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M4.5 12.75l6 6 9-13.5",
  stroke: "#4C5783",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

const SvgCheckThin = props => React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none"
}, props), _ref);

export default SvgCheckThin;